export const unwrapApiData = (payload, fallback = null) => {
  if (payload?.success !== undefined && Object.prototype.hasOwnProperty.call(payload, "data")) {
    return payload.data ?? fallback;
  }

  if (payload?.data?.success !== undefined && Object.prototype.hasOwnProperty.call(payload.data, "data")) {
    return payload.data.data ?? fallback;
  }

  if (Object.prototype.hasOwnProperty.call(payload || {}, "data")) {
    return payload.data ?? fallback;
  }

  return payload ?? fallback;
};

export const unwrapApiList = (payload) => {
  const data = unwrapApiData(payload, []);

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.rows)) return data.rows;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.vaccinations)) return data.vaccinations;

  return [];
};

export const unwrapApiCount = (payload) => {
  const data = unwrapApiData(payload, {});

  if (typeof data === "number") return data;
  if (typeof data?.count === "number") return data.count;
  if (typeof payload?.count === "number") return payload.count;
  if (typeof payload?.data?.count === "number") return payload.data.count;

  return 0;
};

export const unwrapApiMeta = (payload, fallback = {}) => {
  if (payload?.success !== undefined && Object.prototype.hasOwnProperty.call(payload, "meta")) {
    return payload.meta ?? fallback;
  }

  if (payload?.data?.success !== undefined && Object.prototype.hasOwnProperty.call(payload.data, "meta")) {
    return payload.data.meta ?? fallback;
  }

  return payload?.meta || payload?.data?.meta || fallback;
};

export const getAuthToken = () =>
  localStorage.getItem("accessToken") ||
  localStorage.getItem("authToken") ||
  localStorage.getItem("token") ||
  "";
